import { useAppDispatch } from '@/hooks/useReduxHooks';
import { updateCs } from '@/store/modules/cs';
import styled from 'styled-components';
import ICON_CLOCK from '@/assets/cs/icon_clock.png';
import InquiryButtons from '@/components/sideNavigation/Cs/home/InquiryButtons';
import Lottie from 'lottie-react';
import MOTION_MAIN from '@/assets/cs/motion_main.json';
import { Icon } from '@successmode-ktp/kui';
import KTPIcon from '@/assets/common/ktp.png';

function CsHome() {
  const dispatch = useAppDispatch();

  const onOpenChat = () => {
    dispatch(
      updateCs({
        isOpenChat: true,
        hasOpenChatAnimation: true,
      }),
    );
  };

  return (
    <Wrapper>
      <Body>
        <MainSection>
          <Siri>
            <Lottie animationData={MOTION_MAIN} />
          </Siri>
          <Title>
            <KTPImg src={KTPIcon} alt='' />에 문의하기
          </Title>
          <TimeSection>
            <img src={ICON_CLOCK} alt='' width={14} />
            <TimeLabel>운영 시간</TimeLabel>
            <TimeData>24시간 연중무휴</TimeData>
          </TimeSection>
        </MainSection>
        <Footer>
          <InquiryButtons hasOpenChatAnimation />
          <InputButton onClick={onOpenChat}>
            문의하실 내용을 입력하세요
            <SendButton onClick={() => {}} disabled>
              <Icon.Sending fillColor='#A7A7A7' />
            </SendButton>
          </InputButton>
        </Footer>
      </Body>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  height: 100%;
  flex-shrink: 0;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 28px;
`;

const Siri = styled.div`
  width: 192px;
  height: 192px;
`;

const Title = styled.strong`
  margin-bottom: 10px;
  color: #3a3b3e;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
`;

const TimeSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px 6px 10px;
  border-radius: 8px;
  background-color: #f5f6f7;
  color: #80848a;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
`;

const TimeLabel = styled.span`
  position: relative;
  margin-right: 20px;
  margin-left: 6px;
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: -12px;
    transform: translateY(-50%);
    width: 1px;
    height: 11px;
    background-color: #80848a;
  }
`;

const TimeData = styled.span``;

const Footer = styled.div`
  width: 100%;
  padding: 0 14px;
`;

const InputButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  border-radius: 120px;
  padding: 10px 16px 10px 20px;
  margin-bottom: 14px;
  background-color: #f5f6f7;
  border: 1px solid #e5e6e8;
  color: #a7a7a7;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const SendButton = styled.button`
  position: absolute;
  top: 50%;
  right: 17px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  pointer-events: none;
`;
const KTPImg = styled.img`
  width: 31px;
  margin-right: 2px;
`;

export default CsHome;
